
import {
  ref,
  onMounted,
  onUnmounted,
  defineComponent,
  defineEmits,
  watch,
  computed,
} from 'vue';
import { useStore, } from 'vuex';
import { ticketImageIp, blockStatus, } from '@/configs/index';
import {
  DoubleLeftOutlined,
  DoubleRightOutlined,
  EnvironmentFilled,
} from '@ant-design/icons-vue';
import moment from 'moment';
import {
  Modal, Button, Image, Timeline,
} from 'ant-design-vue';
import { validateSearch, } from 'ant-design-vue/lib/vc-mentions/src/util';

const { PreviewGroup, } = Image;

const { Item, } = Timeline;

export default defineComponent({
  components: {
    PreviewGroup,
    Image,
    DoubleLeftOutlined,
    DoubleRightOutlined,
    EnvironmentFilled,
    Item,
    Timeline,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, context) {
    const store = useStore();
    const logList = ref<any>([]);
    const orderType = ref<any>('1');
    const fileLists = ref<any[]>([]);

    watch(
      () => props.data,
      (val) => {
        logList.value = val?.logList?.map((cur:any) => ({ user: {}, ...cur, }));
        orderType.value = val?.orderType;
      }
    );

    const getList = (list:any) => {
      if (!list) return [];

      return list.split(',').map((cur:any) => `${ticketImageIp}${cur}`);
    };

    const timelineVis = ref<boolean>(true);

    const changeTimelineVis = () => {
      timelineVis.value = !timelineVis.value;
    };

    return {
      getList,
      logList,
      orderType,
      timelineVis,
      blockStatus,
      moment,
      changeTimelineVis,
    };
  },
});
